import { ProtocolConsumptionVisit } from "../models/Entities/Protocols/ProtocolConsumptionVisit";
import { IResult } from "../models/HttpResult";

// Functions
import * as Functions from '../functions/common';
import { ProtocolConsumption } from "../models/Entities/Protocols/ProtocolConsumption";

// Base URL
const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'protocols/protocols/';

// Get all visits by protocol id
export const GetAllProtocolVisitByProtocolId = async (
    protocolId: number,
    token: string)
    : Promise<ProtocolConsumptionVisit[]> => {	
    let RequestURL: string = BaseURL + protocolId + '/consumptions/visit';
    try {
        const Response: ProtocolConsumptionVisit[] = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<ProtocolConsumptionVisit[]>>;
            }
        })
        .then((data: IResult<ProtocolConsumptionVisit[]>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// Get protocol visit by id
export const GetProtocolVisitById = async (
    token: string,
    id: string
): Promise<ProtocolConsumptionVisit> => {
    let RequestURL: string = BaseURL + '/consumptions/visit/' + id;
    try {
        const Response: ProtocolConsumptionVisit = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<ProtocolConsumptionVisit>>;
            }
        })
        .then((data: IResult<ProtocolConsumptionVisit>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// Get protocol visit by Stage id
export const GetProtocolVisitByStageId = async (
    token: string,
    protocolId: number,
    stageId: number,
    PatienNumberInProtocol: string
): Promise<ProtocolConsumptionVisit> => {
    let RequestURL: string = BaseURL + protocolId + '/consumptions/visit/' + stageId + '?patientNumberInProtocol=' + PatienNumberInProtocol;
    try {
        const Response: ProtocolConsumptionVisit = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<ProtocolConsumptionVisit>>;
            }
        })
        .then((data: IResult<ProtocolConsumptionVisit>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// Get all consumption by visit id
export const GetAllProtocolConsumptionByVisitId = async (
    token: string,
    protocolId: number,
    stageId: number,
    patientNumberInProtocol: string
): Promise<ProtocolConsumption[]> => {
    let RequestURL: string = BaseURL + protocolId + '/consumptions/stage/' + stageId + '?patientNumberInProtocol=' + patientNumberInProtocol;
    try {
        const Response: ProtocolConsumption[] = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<ProtocolConsumption[]>>;
            }
        })
        .then((data: IResult<ProtocolConsumption[]>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
}